export interface Entry {
  key: string;
  value: string;
}

export interface Transaction {
  amount: number;
  date: string;
  originalDate: string;
  description: string;
  details?: string | null;
  info: string;
  runningBalance: number;
  type: string;
  releaseDate?: string | null;
  isDepositOnHold: boolean;
}

export enum TimeFrameEnum {
  TODAY = "TODAY",
  YESTERDAY = "YESTERDAY",
  WEEK = "WEEK",
  MONTH = "MONTH",
  YTD = "YTD",
  CUSTOM = "CUSTOM"
}

export enum TransactionTypeEnum {
  PROMOTION = "PROMOTION",
  DEPOSIT = "DEPOSIT",
  WITHDRAWAL = "WITHDRAWAL",
  WITHDRAWAL_CANCELLED = "WITHDRAWAL_CANCELLED",
  WAGER_REWARDS = "WAGER_REWARDS",
  HANDICAPPING_STORE = "HANDICAPPING_STORE",
  BET_PLACED = "BET_PLACED",
  BET_WON = "BET_WON",
  BET_CANCELLED = "BET_CANCELLED",
  BET_REFUNDED = "BET_REFUNDED",
  ADJUSTMENT = "ADJUSTMENT"
}

export interface ProcessingTimeMessage {
  processingLabel: string;
  processedLabel: string;
  officiallyProcessedLabel: string;
  paymentTypes: Array<Entry>;
  processingTimeHelp: string;
}

export enum AccountRolesEnum {
  USER = "USER",
  TALENT = "TALENT",
  WAGEROPS = "WAGEROPS",
  ADMIN = "ADMIN"
}
